import { Component } from '@angular/core';

/**
 * This is a dummy component for same page navigation use.
 * Detail: To overcome the issue when doing a same page navigation,
 * the components on the page won't "refresh". So we implemented
 * logic to detect if it is same page navigation. Then we will
 * first navigate to this dummy component without changing
 * anything, then navigate back to the page.
 */
@Component({
  selector: 'app-dummy-refresh',
  template: '',
})
export class DummyRefreshComponent {

}
